import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { IconButton } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useShallow } from 'zustand/react/shallow'
import { useDateStore } from '../../contexts/DateStore'
import './DateController.css'
import ConfirmModal from '../ConfirmModal/ConfirmModal'
import { useCallback, useState } from 'react'
import { useWeekStore } from '../../contexts/WeekStore'

const DateController = ({ className, isWeek = false }) => {
  const { date, setDate } = useDateStore(
    useShallow((state) => ({
      date: state.date,
      setDate: state.setDate,
    }))
  )
  const { isDirty } = useWeekStore(
    useShallow((state) => ({
      isDirty: state.isDirty,
    }))
  )
  const [nextWantedDate, setNextWantedDate] = useState(false)

  const onChangeDate = useCallback(
    (newDate) => {
      if (isDirty) {
        setNextWantedDate(newDate)
      } else {
        setDate(newDate)
      }
    },
    [isDirty, setDate]
  )

  const effectivlySetDate = () => {
    setDate(nextWantedDate)
  }

  const next = () => {
    onChangeDate(date.add(1, isWeek ? 'week' : 'day'))
  }
  const prev = () => {
    onChangeDate(date.add(-1, isWeek ? 'week' : 'day'))
  }
  return (
    <div className={`${className} datePickerWrapper`}>
      <IconButton onClick={prev} color="primary" className="arrow">
        <KeyboardArrowLeftIcon />
      </IconButton>
      <DatePicker
        closeOnSelect
        views={['month', 'day']}
        format="DD/MM/YYYY"
        className="noPrint datePickerElement"
        slotProps={{ textField: { size: 'small' } }}
        label="Date"
        value={date}
        onChange={(newValue) => onChangeDate(newValue)}
      />
      <IconButton onClick={next} color="primary" className="arrow">
        <ChevronRightIcon />
      </IconButton>
      <ConfirmModal
        title="Attention"
        text={'Vous avez des modifications non enregistrées, voulez-vous vraiment partir ?'}
        txtConfirm="Oui"
        isOpen={!!nextWantedDate}
        setIsOpen={setNextWantedDate}
        onConfirm={effectivlySetDate}
        onCancel={() => setNextWantedDate(false)}
      />
    </div>
  )
}
export default DateController
